import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminStationBatch, AdminStationResponse, AdminStation, StationsDataService } from '@mol-limo-reg/admin-api';

@Injectable({
  providedIn: 'root',
})
export class StationService {
  constructor(private readonly stationsDataService: StationsDataService) {}

  public getStations$(limit: number, offset: number, q?: string): Observable<AdminStationBatch> {
    return this.stationsDataService.getStations(limit, offset, q, 'body');
  }

  public getStationByKey$(stationId: string): Observable<AdminStationResponse> {
    return this.stationsDataService.getStationByKey(stationId, 'body');
  }

  public updateStationByKey$(stationId: string, station: AdminStation): Observable<any> {
    return this.stationsDataService.updateStationByKey(stationId, station, 'body');
  }
}
